import EditPost from "./EditPost"
import checkIcon from '../../../../../assests/dashboard/friends/check.png'
import classes from './CollapsePost.module.css'
import { useSelector } from "react-redux";
import Moment from 'moment';
import { TargetObjectIdEnum } from "../../../../../models/TargetObjectIdEnum";
import { onKeyDown } from "../../../../../service";

const CollapsePost = ({ friendsData, allPost, setDataPost, setBeenSharedBefore, optionsSelect, setOptionsSelect, editPostFromPosts, close, index, setShowEditPost, showEditPost, setShowPopup, dataPost, postDescriptionType, project, beenSharedBefore, setProjectData, getSelectedList, showNewEditPost, changePosts, setNewPost, newPost, saveVersion }) => {

    const { direction, texts } = useSelector((state) => state.translate);

    const getText = () => {
        if (dataPost.shares[0].targetObjectId === TargetObjectIdEnum.External) {
            return texts.linkCreated;
        }
        return texts.successPublishPost;
    }

    return (
        <div>
            <div className={`${classes[direction]} ${classes.SuccessIconAndText}`}  >
                <div className={classes.TypeAndDateWarrper}>
                    <img src={checkIcon} className={classes.Icon} alt='CheckIcon' />
                    <div className={classes.PostType}>{postDescriptionType}</div>
                    <p className={classes.Text}>{getText()} {texts.onDate} {Moment(dataPost?.updatedDate).format('DD.MM.YY')}</p>
                </div>
                {!editPostFromPosts && <div className={`${showEditPost ? classes.OpenIcon : classes.CloseIcon}`} onClick={() => setShowEditPost(index)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowEditPost(index))}></div>}
            </div>
            {showEditPost && <EditPost index={index} allPost={allPost} setDataPost={setDataPost} newPost={newPost} setNewPost={setNewPost} setOptionsSelect={setOptionsSelect} optionsSelect={optionsSelect} editPostFromPosts={editPostFromPosts} showNewEditPost={showNewEditPost} close={() => close()} getSelectedList={getSelectedList} setShowPopup={setShowPopup} setProjectData={setProjectData} dataPost={dataPost} project={project} beenSharedBefore={beenSharedBefore} setBeenSharedBefore={setBeenSharedBefore} changePosts={changePosts} friendsData={friendsData} saveVersion={saveVersion} />}
            {!editPostFromPosts && <div className={classes.Line}></div>}

        </div>
    )
}
export default CollapsePost 